import React, { useEffect } from "react";
import Periodos from "../components/Periodos/Periodos";
import i18n from "../i18n/config";

const PeriodosPage = () => {
  useEffect(() => {
    document.title = `${window._env_.REACT_APP_EMPRESA_NAME} - ${i18n.t("list.breadcrumb", { ns: "periodos" })}`;
  }, []);

  return <Periodos />;
};

export default PeriodosPage;
